import { useApiQuery } from '@/hooks/useApiQuery';
import { apiPost, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { StripeAccountSessionResponse } from '@/types/settings';

export function useStripeAccountSession(enabled = true) {
  return useApiQuery<StripeAccountSessionResponse>({
    queryKey: settingsKeys.stripeAccountSession(),
    queryFn: () =>
      apiPost<StripeAccountSessionResponse>(
        operationsClient,
        settingsEndpoints.stripeAccountSession(),
      ),
    enabled,
    showErrorToast: false,
    retry: false,
  });
}
